<svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M0.75 0.699219H11.25C11.6642 0.699219 12 1.03756 12 1.45491V15.9213C12 16.1299 11.8321 16.2992 11.625 16.2992C11.5546 16.2992 11.4855 16.2791 11.4258 16.2414L6 12.8139L0.574193 16.2414C0.398723 16.3523 0.167295 16.2988 0.0572773 16.122C0.0198523 16.0619 0 15.9923 0 15.9213V1.45491C0 1.03756 0.33579 0.699219 0.75 0.699219ZM10.5 2.2106H1.5V13.8727L6 11.03L10.5 13.8727V2.2106Z"
    fill="white"
  />
</svg>
